import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pay-gateway-dialog',
  templateUrl: './pay-gateway-dialog.component.html',
  styleUrls: ['./pay-gateway-dialog.component.scss']
})
export class PayGatewayDialogComponent implements OnInit {
  payGatewayDialogForm: FormGroup;
  isSubmitButton: boolean = true;
  isEditButton: boolean = false;
  isRead: boolean = false;
  submitpayload: any;
  paymentGatewayList: any;

  dialogRef: MatDialogRef<any>;

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    
    window.scroll(0, 0);
    this.isSubmitButton = true;
    this.isEditButton = false;
    this.getPaymentGatewayData();
    this.payGatewayDialogForm = this.fb.group({
      gatewayName: new FormControl ('', [Validators.required]),
      isActive: new FormControl ('', [Validators.required]),
     // paymentGateId: new FormControl ('', [Validators.required]),
  });
 
  if (this.data.key == "Edit") {
    this.prepopulation(this.data.selected);
  }

  }

  prepopulation(id) {
    this.isEditButton = true;
    this.isSubmitButton = false;
    this.isRead = true;
    sessionStorage.setItem('gatewayName', id.gatewayName);
    sessionStorage.setItem('isActive', id.isActive);
    this.payGatewayDialogForm = this.fb.group({
      gatewayName: new FormControl(id.gatewayName, [
        Validators.required
      ]),
      isActive: new FormControl(id.isActive, [
        Validators.required
      ]),
    });
  }

  // prepopulation(id) {
  //   this.spinner.show();
  //   const payload = {};
  //   payload['gatewayName'] = id.gatewayName;
  //   this.umsService.getPaymentGateway(payload).subscribe((res) => {
  //     this.spinner.hide();
  //     const data = res.data[0];
  //     if (res.status){
  //        this.isEditButton = true;
  //        this.isSubmitButton = false;
  //        this.isRead = true;
  //        this.payGatewayDialogForm = this.fb.group({
  //         gatewayName: new FormControl (data.gatewayName, [Validators.required,]),
  //         isActive: new FormControl (data.isActive, [Validators.required]),
  //       });
  //      }else{
         
  //      }
  //    });
  // }

  getPaymentGatewayData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getPaymentGateway(payload).subscribe(res => {
      if(res.status){
        this.paymentGatewayList = res.data;
        this.spinner.hide();
      }else{
        this.spinner.hide();
      }
      
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.paymentGatewayList = [];
       
     });
  }

  submit() {
    if (this.payGatewayDialogForm.invalid) {
      this.payGatewayDialogForm.get('gatewayName').markAsTouched();
      this.payGatewayDialogForm.get('isActive').markAsTouched();
      return;
    } else {
      this.createPaymentGatewayType();
    }
  }

  createPaymentGatewayType() {
    this.spinner.show();
    this.submitpayload = this.payGatewayDialogForm.value;
    this.umsService.addPaymentGatewayType(this.submitpayload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          sessionStorage.setItem('gatewayName', this.submitpayload.gatewayName);
          sessionStorage.setItem('isActive', this.submitpayload.isActive);
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.ngOnInit();
      }
    );
  }

  update(){
    if (this.payGatewayDialogForm.invalid) {
      this.payGatewayDialogForm.get('gatewayName').markAsTouched();
      this.payGatewayDialogForm.get('isActive').markAsTouched();
      return;
    } else {
      this.updatePaymentGatewayType();
    }
  }

  updatePaymentGatewayType() {
    this.spinner.show();
    this.submitpayload = this.payGatewayDialogForm.value;
    this.umsService.updatePaymentGatewayType(this.submitpayload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          sessionStorage.setItem('gatewayName', this.submitpayload.gatewayName);
          sessionStorage.setItem('isActive', this.submitpayload.isActive);
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  // updatePaymentGatewayType() {
  //   this.spinner.show();
  //   this.submitpayload = this.payGatewayDialogForm.value;
  //   this.umsService.updatePaymentGatewayType(this.submitpayload).subscribe(res => {
  //     this.spinner.hide();
  //     if (res.status){
  //       let  data = {}
  //       data['message'] = res.message
  //       data['title'] = 'Information'
  //       data['icon'] = 'fas fa-check'
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       this.ngOnInit();
  //     } else {
  //       this.spinner.hide();
  //       let  data = {}
  //       data['message'] = res.message
  //       data['title'] = 'Information'
  //       data['icon'] = 'fas fa-check'
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       this.ngOnInit();
  //     }
  //   }, (ERROR: HttpErrorResponse) => {
  //     this.spinner.hide();
  //     let  data = {} 
  //     data['message'] = ERROR.error.message
  //     data['title'] = 'Information'
  //     data['icon'] = 'fas fa-box-open'
  //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //     this.ngOnInit();
  //   });
  // }

}
